import { twMerge } from "tailwind-merge"

export type AvatarCardProps = {
    leading?: React.ReactNode
    title: string
    titleClassName?: string
    subTitle?: string
    subTitleClassName?: string
    trailing?: React.ReactNode
}

const AvatarCard = (props: AvatarCardProps) => {

    return (
        <div className="flex items-center gap-3">
            {props.leading}
            <div className="flex-1 text-left pr-3">
                <h5 
                    className={twMerge(
                        "text-xs text-secondary font-semibold", 
                        props.titleClassName
                    )}
                >
                    {props.title}
                </h5>
                <p 
                    className={twMerge(
                        "text-xs text-secondary font-light",
                        props.subTitleClassName
                    )}
                >
                    {props.subTitle}
                </p>
            </div>
            {props.trailing}
        </div>
    )
}

export default AvatarCard